import React from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Space,
  InputNumber,
} from 'antd';
import moment from 'moment';
import DebounceSelect from '../../Forms/DebounceSelect';
import formatAmount from 'indian-currency-formatter';
import * as Config from '../../../appConfig';
import { activePeriod, disabledDate, isSunday } from '../../../utils/date';

const AddDeductionForm = ({
  deduction,
  lookupData,
  onLookup,
  types,
  onDeductionSubmit,
  onCancelClick,
  fetching,
  ability,
}) => {
  const [form] = Form.useForm();

  const [selectedEmployee, setSelectedEmployee] = React.useState(
    deduction
      ? {
          value: `${deduction.employee.id}`,
          label: `${deduction.employee.first_name} ${deduction.employee.last_name} (${deduction.employee.emp_id})`,
        }
      : {}
  );

  console.log('selectedEmployee ////', selectedEmployee);

  const [freezePrevMonth, currentMonth, prevMonth] = activePeriod();

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        size="large"
        className="ant-form-custom"
        initialValues={{
          id: deduction && deduction.id,
          deduction_type_id:
            deduction &&
            deduction.deduction_type &&
            deduction.deduction_type.id,
          for_month:
            deduction && deduction.for_month && moment(deduction.for_month),
          amount: deduction && deduction.amount,
          note: deduction && deduction.note,
          employee: selectedEmployee,
        }}
        onFinish={(values) =>
          onDeductionSubmit(values, (updated) => {
            if (updated.status === 2) {
              // setShowRelieveModal(false);
            }
          })
        }
        style={{ marginTop: '0' }}
      >
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Employee"
              name="employee"
              rules={[
                {
                  required: true,
                  message: 'Please input Employee!',
                },
              ]}
            >
              <DebounceSelect
                showSearch={deduction && deduction.id ? false : true}
                disabled={deduction && deduction.id ? true : false}
                defaultValue={selectedEmployee}
                value={selectedEmployee}
                placeholder="Search employee"
                data={
                  lookupData && lookupData.length
                    ? lookupData
                    : deduction
                    ? [
                        {
                          label: `${deduction.employee.first_name} ${deduction.employee.last_name} (${deduction.employee.emp_id})`,
                          value: deduction.employee.id,
                        },
                      ]
                    : []
                }
                onLookup={onLookup}
                onChange={(newValue) => {
                  setSelectedEmployee(newValue);
                }}
                style={{
                  width: '100%',
                }}
                fetching={fetching}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Form.Item
              label="Deduction Type"
              name="deduction_type_id"
              rules={[
                {
                  required: true,
                  message: 'Please select Deduction Type!',
                },
              ]}
            >
              <Select placeholder="Please select">
                {types &&
                  types.map((type) => (
                    <Select.Option key={type.id} value={type.id}>
                      {type.name} ({type.code})
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Month"
              name="for_month"
              rules={[
                {
                  required: true,
                  message: 'Please select Month!',
                },
              ]}
            >
              <DatePicker
                disabledDate={(current) =>
                  disabledDate(
                    current,
                    freezePrevMonth,
                    currentMonth,
                    prevMonth
                  ) || isSunday(current)
                }
                format={Config.DATE_MONTH_INPUT}
                picker="month"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={12}>
            <Form.Item
              label="Amount"
              name="amount"
              rules={[
                {
                  required: true,
                  message: 'Please input Amount!',
                },
              ]}
            >
              <InputNumber
                formatter={(value) => formatAmount(value)}
                parser={(value) => value.replace(/(,*)/g, '')}
                style={{
                  width: '170px',
                }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Form.Item label="Note" name="note">
              <Input placeholder="Note" maxLength="255" />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} align="right">
            <Space>
              <Button type="secondary" size="middle" onClick={onCancelClick}>
                Cancel
              </Button>
              <Button type="primary" size="middle" htmlType="submit">
                Save
              </Button>
            </Space>
          </Col>
        </Row>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
      </Form>
    </>
  );
};

export default AddDeductionForm;
